import {useQuery} from 'react-query';

import getRange from '.';

const useGetRange = (inputGroupGuid?: string) => {
  const {data, isLoading} = useQuery(
    ['get-range', inputGroupGuid],
    () => getRange({inputGroupGuid}),
    {enabled: inputGroupGuid ? true : false},
  );

  return {data, isLoading};
};

export default useGetRange;
